// import common component classes
import {DeveloperBar} from './developer-bar/developer-bar.ts'
import {VolumeButton} from './volume-button/volume-button.ts'
import {FullscreenButton} from './fullscreen-button/fullscreen-button.ts'
import {HelpButton} from './help-button/help-button.ts'
import {ColorPicker} from './color-picker/color-picker.ts'
import {ModalWindow} from './modal-window/modal-window.ts'
import {Carousel} from './carousel/carousel.ts'
import {RoundButton} from './round-button/round-button.ts'
import {IconButton} from './icon-button/icon-button.ts'
import {AdBanner} from './ad-banner/ad-banner.ts'
import {Footer} from './footer/footer.ts'

// bundle component classes into angular components
export default angular.module('app.common.components', [])
.component('developerBar', new DeveloperBar())
.component('volumeButton', new VolumeButton())
.component('fullscreenButton', new FullscreenButton())
.component('helpButton', new HelpButton())
.component('colorPicker', new ColorPicker())
.component('modalWindow', new ModalWindow())
.component('carousel', new Carousel())
.component('roundButton', new RoundButton())
.component('iconButton', new IconButton())
.component('adBanner', new AdBanner())
.component('footer', new Footer())




/** WEBPACK FOOTER **
 ** ./src/common/components/components.ts
 **/